import { PATHS } from '@/infrastructure/utils/route-constants';
import authenticated from '@/infrastructure/vue/middleware/authenticated';
import redirectHome from '@/infrastructure/vue/middleware/redirectHome';
import authorized from '@/infrastructure/vue/middleware/authorized';

export default [
  {
    path: '*',
    redirect: {
      path: PATHS.errors.notFound,
    },
  },
  {
    path: '/',
    meta: {},
    name: 'Root',
    redirect: {
      name: 'DashboardPage',
    },
  },

  /* ############################# */
  /*         ERROR PAGES         */
  /* ############################# */

  {
    path: PATHS.errors.notFound,
    name: 'NotFoundPage',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/errors/NotFoundPage.vue`
      ),
  },
  {
    path: PATHS.errors.deny,
    name: 'DenyPage',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/errors/DenyPage.vue`
      ),
  },
  {
    path: PATHS.errors.serverError,
    name: 'ErrorPage',
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/errors/ErrorPage.vue`
      ),
  },

  /* ############################# */
  /*         PRIVATE PAGES         */
  /* ############################# */

  {
    path: PATHS.dashboard.pathBase,
    name: 'DashboardPage',
    meta: {
      private: true,
      middleware: [authenticated, authorized],
    },
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/private/DashboardPage`
      ),
  },

  /* Ticket */
  {
    path: PATHS.ticket.pathBase,
    name: 'TicketPage',
    meta: {
      private: true,
      middleware: [authenticated, authorized],
    },
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/infrastructure/vue/pages/private/ticket`
        ),
    },
    children: [
      {
        path: PATHS.ticket.generateVirtualTicket,
        name: 'GenerateVirtualTicket',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/ticket/GenerateVirtualTicket`
            ),
        },
      },
      {
        path: PATHS.ticket.generatePresentialTicket,
        name: 'GeneratePresentialTicket',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/ticket/GeneratePresentialTicket`
            ),
        },
      },
    ],
  },

  /* Box */
  {
    path: PATHS.box.pathBase,
    name: 'BoxPage',
    meta: {
      private: true,
      middleware: [authenticated, authorized],
    },
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/infrastructure/vue/pages/private/box`
        ),
    },
    children: [
      {
        path: PATHS.box.assignmentBox,
        name: 'AssignmentBox',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/box/AssignmentBox`
            ),
        },
      },
      {
        path: PATHS.box.attentionBox,
        name: 'AttentionBox',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/box/AttentionBox`
            ),
        },
      },
    ],
  },

  /* Citas Virtuales */
  {
    path: PATHS.reservation.pathBase,
    name: 'ReservationPage',
    meta: {
      private: true,
      middleware: [authenticated, authorized],
    },
    components: {
      default: () =>
        import(
          /* webpackChunkName: "routes" */
          /* webpackMode: "lazy-once" */
          `@/infrastructure/vue/pages/private/cita`
        ),
    },
    children: [
      {
        path: PATHS.reservation.virtualReservation,
        name: 'VirtualReservation',
        meta: {
          private: true,
          middleware: [authenticated, authorized],
        },
        components: {
          default: () =>
            import(
              /* webpackChunkName: "routes" */
              /* webpackMode: "lazy-once" */
              `@/infrastructure/vue/pages/private/cita/VirtualReservation`
            ),
        },
      },
    ],
  },

  /* ############################# */
  /*         PUBLIC PAGES          */
  /* ############################# */

  {
    path: PATHS.login.pathBase,
    name: 'LoginPage',
    meta: {
      middleware: redirectHome,
    },
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        /* webpackMode: "lazy-once" */
        `@/infrastructure/vue/pages/public/LoginPage`
      ),
  },
];
